import { render, staticRenderFns } from "./IconBell.vue?vue&type=template&id=19d1efc8&"
import script from "./IconBell.vue?vue&type=script&lang=js&"
export * from "./IconBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports